<div class="modal-content">
	<div class="modal-header">
		<h5 data-testid="SUBSYS2_CLONEDLIST_TITLE_TXT" class="modal-title">
			{{ labels().CLONED_LIST_MODAL_COMPONENT_TITLE }} &nbsp; {{ originalPlanId | replaceLongLeg }}
		</h5>
		<button data-testid="SUBSYS2_CLONEDLIST_CLOSE_BTN" type="button" class="btn-close" data-dismiss="modal"
			aria-label="Close" (click)="activeModal.close()" ngbAutoFocus></button>
	</div>
	<div class="modal-body">

		@if (!clonedList.length) {
		<div class="row">
			<div class="col-12">
				<span data-testid="SUBSYS2_CLONEDLIST_EMPTY_TXT">
					{{ labels().CLONED_LIST_MODAL_COMPONENT_EMPTY_LIST_MESSAGE }}
				</span>
			</div>
		</div>
		} @else {

		<div class="row">
			<div class="col-5">
				<label data-testid="SUBSYS2_CLONEDLIST_HEADER_PATID" for="patientId">
					{{ labels().CLONED_LIST_MODAL_COMPONENT_PATIENT_ID }}
				</label>
			</div>
			<div class="col-5">
				<label data-testid="SUBSYS2_CLONEDLIST_HEADER_PLANID" for="planId">
					{{ labels().CLONED_LIST_MODAL_COMPONENT_PLAN_ID }}
				</label>
			</div>
			<div class="col-2"></div>
		</div>

		<hr />

		<div class="list">

			@for (item of clonedList; track item.planId) {
			<div class="row">
				<div class="col-5">
					<span data-testid="SUBSYS2_CLONEDLIST_PATID_BTN" class="a-link"
						[title]="labels().CLONED_LIST_MODAL_COMPONENT_EDIT_PATIENT" (click)="editPatient(item.patientId)"
						(keypress)="editPatient(item.patientId)">
						{{ item.patientNumber }}
					</span>
				</div>
				<div class="col-5">
					<span data-testid="SUBSYS2_CLONEDLIST_PLANID_BTN" class="a-link"
						[title]="labels().CLONED_LIST_MODAL_COMPONENT_EDIT_PLAN" (click)="editPlan(item.planId!)"
						(keypress)="editPlan(item.planId!)">
						{{ item.planNumber }}
					</span>
				</div>
				<div class="col-2 action">
					<i data-testid="SUBSYS2_CLONEDLIST_ANALYSIS_BTN" class="material-icons"
						[title]="labels().CLONED_LIST_MODAL_COMPONENT_ANALYSIS" (click)="navigateToApp(item)"
						(keypress)="navigateToApp(item)">square_foot</i>
				</div>
			</div>

			<hr />
			}

		</div>

		}

	</div>

	@if (clonedList && clonedList.length > -1) {
	<div class="modal-footer">
		<span class="result">{{ clonedList.length }} {{ labels().CLONED_LIST_MODAL_COMPONENT_RESULTS }}</span>
	</div>
	}

</div>